<template>
  <section class="IndexShipmentlLeader">
    <div v-if="show_monitor" class="left" :style="posLeftSt">
      <div
        class="mainDiv-br"
        v-for="(item, index) in monitorList"
        :key="index"
      ></div>
    </div>
    <div class="right" :style="posRightSt">
      <p class="tittleP">
        玖龙智通管理系统
        <span class="manualChangeComId" @click="manualChangeComId">
          『 {{ comInfoObj.com_info && comInfoObj.com_info.name }}』</span
        >
        发运数据大屏
      </p>
      <p class="titleTime">{{ nowTime }}</p>
      <img class="tittlePng" :src="tittlePng" alt />
      <div class="mainDiv">
        <div class="mainDivl">
          <p class="mainDivl-title">
            <span class="text">今日未进厂车次:</span>
            <span class="num1">{{ listCarNumberObj.not_info_car_number }}</span>
            <span class="lineColumn"></span>
            <span class="text">正在排队:</span>
            <span class="num2">{{ listCarNumberObj.queuing_car_number }}</span>
            <span class="text">正在叫号:</span>
            <span class="num2">{{ listCarNumberObj.call_car_number }}</span>
            <span class="text">正在装车:</span>
            <span class="num2">{{ listCarNumberObj.loading_car_number }}</span>
          </p>
          <div class="mainDivl-m">
            <div class="mainDivl-m-l">
              <div class="mainDivl-m-l-m1">
                <div class="title">
                  <span
                    >总装卸平台:{{ listWarehouseObj.total_parking }} 个</span
                  >
                </div>
                <div class="working">
                  <span class="icon"></span>
                  <span>
                    作业中:
                    <span class="num">{{ listWarehouseObj.in_busy }}</span>
                    个
                  </span>
                </div>
                <div class="emptying">
                  <span class="icon"></span>
                  <span>
                    空闲中:
                    <span class="num">{{ listWarehouseObj.in_idle }}</span
                    >个
                  </span>
                </div>
              </div>
              <div class="mainDivl-m-l-m2">
                <vue-seamless-scroll
                  :data="listWarehouseObj.warehouse"
                  :class-option="optionButtom1"
                  ref="listWarehouseObjElement"
                  class="factoryMainDiv"
                >
                  <div
                    class="factoryDiv"
                    v-for="(item, index) in listWarehouseObj.warehouse"
                    :key="index"
                  >
                    <div class="title">{{ item.name }}</div>
                    <div class="carStateDiv">
                      <div
                        class="carState"
                        v-for="(location, localtionIndex) in item.location"
                        :key="localtionIndex"
                      >
                        <span
                          v-show="location.state == 0"
                          class="working"
                        ></span>
                        <span
                          v-show="location.state == 0"
                          class="workingText"
                          >{{ location.name }}</span
                        >
                        <span
                          v-show="location.state == 1"
                          class="emptying"
                        ></span>
                        <span
                          v-show="location.state == 1"
                          class="emptyingText"
                          >{{ location.name }}</span
                        >
                      </div>
                    </div>
                  </div>
                </vue-seamless-scroll>
              </div>
              <div class="mainDivl-m-l-m3 mainDiv-br">
                <div class="title">
                  <span>今日离厂车次:</span>
                  <span class="num">{{ listLeaveCarObj.count }}</span>
                </div>
                <div class="datahead">
                  <span class="sp1">车牌号</span>
                  <span class="sp2">物流单位</span>
                  <!-- <span class="sp2">产品线</span> -->
                  <span class="sp3">离厂时间</span>
                </div>
                <vue-seamless-scroll
                  :data="listLeaveCarObj.items"
                  :class-option="optionButtom2"
                  ref="listLeaveCarObjElement"
                  @ScrollEnd="listLeaveCarSroolEndFun"
                  class="datarowDiv"
                >
                  <div
                    v-for="(item, index) in listLeaveCarObj.items"
                    :key="index"
                  >
                    <div class="datarow">
                      <span class="sp1 lineHide">
                        <template
                          v-if="
                            item.license_plate == undefined ||
                              item.license_plate.length == 0
                          "
                          >--</template
                        >
                        <template v-else>{{ item.license_plate }}</template>
                      </span>
                      <span class="sp2 lineHide">
                        <template v-if="item.unit_short_name.length == 0">
                          --
                        </template>
                        <template v-else>
                          {{ item.unit_short_name }}
                        </template>
                      </span>
                      <!-- <span class="sp2 lineHide">{{
                        businessNameText(item.business)
                      }}</span> -->
                      <span class="sp3 lineHide">
                        <template
                          v-if="
                            item.leave_factory_time == undefined ||
                              item.leave_factory_time.length == 0
                          "
                          >--</template
                        >
                        <template v-else>{{
                          formatTime(item.leave_factory_time)
                        }}</template>
                      </span>
                    </div>
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
            <div class="mainDivl-m-r">
              <!-- 装车中、排队中滚动列表 -->
              <div class="mainDivl-m-r-m1 mainDiv-br">
                <div class="titleDiv">
                  <div
                    :class="
                      'cpoint titleDivL ' +
                        (tabSwitchActive == 1 ? 'active' : '')
                    "
                    @click="
                      tabSwitchActiveEnd = false;
                      tabSwitchActiveClick = true;
                      tabSwitchActive = 1;
                    "
                  >
                    <span>装车中:</span>
                    <span class="num">
                      {{ listLoadingCarDroom.items.length }}
                    </span>
                  </div>
                  <div
                    :class="
                      'cpoint titleDivR ' +
                        (tabSwitchActive == 2 ? 'active' : '')
                    "
                    @click="
                      tabSwitchActiveEnd = false;
                      tabSwitchActiveClick = true;
                      tabSwitchActive = 2;
                    "
                  >
                    <span>排队中:</span>
                    <span class="num">
                      {{ listQueueCarDroom.items.length }}
                    </span>
                  </div>
                  <div
                    :class="
                      'cpoint titleDivR  ' +
                        (tabSwitchActive == 3 ? 'active' : '')
                    "
                    @click="
                      tabSwitchActiveEnd = false;
                      tabSwitchActiveClick = true;
                      tabSwitchActive = 3;
                    "
                  >
                    <span>已报到: </span>
                    <span class="num">{{
                      listReportCarDroom.items.length
                    }}</span>
                  </div>
                  <div
                    :class="
                      'cpoint titleDivR  ' +
                        (tabSwitchActive == 4 ? 'active' : '')
                    "
                    @click="
                      tabSwitchActiveEnd = false;
                      tabSwitchActiveClick = true;
                      tabSwitchActive = 4;
                    "
                  >
                    <span>未进厂: </span>
                    <span class="num">{{
                      listUnApproachCarDroom.items.length
                    }}</span>
                  </div>
                </div>
                <div class="DataDiv">
                  <div v-if="tabSwitchActive == 1" class="datahead">
                    <!-- <span class="sp1">排队编号</span> -->
                    <span class="sp2">车牌号</span>
                    <span class="sp3">物流单位</span>
                    <!-- <span class="sp4">产品线</span> -->
                    <span class="sp4">预约时间</span>
                    <span class="sp5">装车状态</span>
                    <span class="sp6">装车耗时</span>
                  </div>
                  <div v-if="tabSwitchActive == 2" class="datahead">
                    <!-- <span class="sp1">排队编号</span> -->
                    <span class="sp2">车牌号</span>
                    <span class="sp3">物流单位</span>
                    <!-- <span class="sp4">产品线</span> -->
                    <span class="sp4">预约时间</span>
                    <span class="sp5">进厂时间</span>
                    <span class="sp6">排队状态</span>
                  </div>
                  <div v-if="tabSwitchActive == 3" class="datahead">
                    <!-- <span class="sp1">排队编号</span> -->
                    <span class="sp-p17">车牌号</span>
                    <span class="sp-p29">物流单位</span>
                    <span class="sp-p27">预约时间</span>
                    <span class="sp-p27">报到时间</span>
                  </div>
                  <div v-if="tabSwitchActive == 4" class="datahead">
                    <!-- <span class="sp1">排队编号</span> -->
                    <span class="sp-p20">车牌号</span>
                    <span class="sp-p40">物流单位</span>
                    <span class="sp-p40">预约时间</span>
                  </div>

                  <vue-seamless-scroll
                    v-if="tabSwitchActive == 1"
                    :data="listLoadingCarDroom.items"
                    :class-option="optionButtom3"
                    ref="listLoadingCarDroomElement"
                    @ScrollEnd="playScrollEnd"
                    class="datarowDiv"
                  >
                    <div
                      v-for="(item, index) in listLoadingCarDroom.items"
                      :key="index"
                    >
                      <div class="datarow">
                        <!-- 
                          <span class="sp1 lineHide">
                          <template v-if="item.queue_code.length == 0">
                            --
                          </template>
                          <template v-else>
                            {{ item.queue_code }}
                          </template>
                        </span> 
                        -->
                        <span class="sp2 lineHide">
                          <template
                            v-if="
                              item.license_plate == undefined ||
                                item.license_plate.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{ item.license_plate }}</template>
                        </span>
                        <span class="sp3 lineHide">
                          <template
                            v-if="
                              item.unit_short_name == undefined ||
                                item.unit_short_name.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{ item.unit_short_name }}</template>
                        </span>
                        <!-- 
                        <span class="sp4 lineHide">
                          <template
                            v-if="
                              item.business_name == undefined ||
                                item.business_name.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{ item.business_name }}</template>
                        </span>
                         -->
                        <span class="sp4 lineHide">
                          {{ formatBookingTime(item.booking_day) }}
                          {{ item.begin_time }}至{{ item.end_time }}
                        </span>
                        <span class="sp5 lineHide">
                          <template
                            v-if="
                              item.loading_state == undefined ||
                                item.loading_state.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{
                            loadingStateText(item.loading_state)
                          }}</template>
                        </span>
                        <span class="sp6 lineHide">
                          <template
                            v-if="
                              item.begin_loading_time == undefined ||
                                item.begin_loading_time.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{
                            timeCaclFormat(item.begin_loading_time)
                          }}</template>
                        </span>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                  <vue-seamless-scroll
                    v-if="tabSwitchActive == 2"
                    :data="listQueueCarDroom.items"
                    :class-option="optionButtom3"
                    ref="listQueueCarDroomElement"
                    @ScrollEnd="playScrollEnd"
                    class="datarowDiv"
                  >
                    <div
                      v-for="(item, index) in listQueueCarDroom.items"
                      :key="index"
                    >
                      <div class="datarow">
                        <!-- 
                          <span class="sp1 lineHide">
                          <template v-if="item.queue_code.length == 0">
                            --
                          </template>
                          <template v-else>
                            {{ item.queue_code }}
                          </template>
                        </span> 
                        -->
                        <span class="sp2 lineHide">
                          <template
                            v-if="
                              item.license_plate == undefined ||
                                item.license_plate.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{ item.license_plate }}</template>
                        </span>
                        <span class="sp3 lineHide">
                          <template
                            v-if="
                              item.unit_short_name == undefined ||
                                item.unit_short_name.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{ item.unit_short_name }}</template>
                        </span>
                        <!-- 
                        <span class="sp4 lineHide">
                          <template
                            v-if="
                              item.business_name == undefined ||
                                item.business_name.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{ item.business_name }}</template>
                        </span> 
                        -->
                        <span class="sp4 lineHide">
                          {{ formatBookingTime(item.booking_day) }}
                          {{ item.begin_time }}至{{ item.end_time }}
                        </span>
                        <span class="sp5 lineHide">
                          <template
                            v-if="
                              item.into_factory_time == undefined ||
                                item.into_factory_time.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{
                            formatTime(item.into_factory_time)
                          }}</template>
                        </span>
                        <span
                          :class="
                            'sp6 lineHide ' +
                              queueStateTextColor(item.queue_state)
                          "
                        >
                          <template
                            v-if="
                              item.queue_state == undefined ||
                                item.queue_state.length == 0
                            "
                            >--</template
                          >
                          <template v-else>{{
                            queueStateText(item.queue_state)
                          }}</template>
                        </span>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                  <vue-seamless-scroll
                    v-if="tabSwitchActive == 3"
                    :data="listReportCarDroom.items"
                    :class-option="optionButtom3"
                    ref="listReportCarDroomElement"
                    @ScrollEnd="playScrollEnd"
                    class="datarowDiv"
                  >
                    <div
                      v-for="(item, index) in listReportCarDroom.items"
                      :key="index"
                    >
                      <div class="datarow">
                        <span class="sp-p17 lineHide">
                          <template
                            v-if="
                              item.license_plate == undefined ||
                                item.license_plate.length == 0
                            "
                          >
                            --
                          </template>
                          <template v-else>
                            {{ item.license_plate }}
                          </template>
                        </span>

                        <span class="sp-p29 lineHide">
                          <template
                            v-if="
                              item.unit_short_name == undefined ||
                                item.unit_short_name.length == 0
                            "
                          >
                            --
                          </template>
                          <template v-else>
                            {{ item.unit_short_name }}
                          </template>
                        </span>
                        <span class="sp-p27 lineHide">
                          {{ formatBookingTime(item.booking_day) }}
                          {{ item.begin_time }}至{{ item.end_time }}
                        </span>
                        <span class="sp-p27 lineHide ">
                          <template
                            v-if="
                              item.report_time == undefined ||
                                item.report_time.length == 0
                            "
                          >
                            --
                          </template>
                          <template v-else>
                            {{ formatTime(item.report_time) }}
                          </template>
                        </span>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                  <vue-seamless-scroll
                    v-if="tabSwitchActive == 4"
                    :data="listUnApproachCarDroom.items"
                    :class-option="optionButtom3"
                    ref="listUnApproachCarDroomElement"
                    @ScrollEnd="playScrollEnd"
                    class="datarowDiv"
                  >
                    <div
                      v-for="(item, index) in listUnApproachCarDroom.items"
                      :key="index"
                    >
                      <div class="datarow">
                        <span class="sp-p20 lineHide">
                          <template
                            v-if="
                              item.license_plate == undefined ||
                                item.license_plate.length == 0
                            "
                          >
                            --
                          </template>
                          <template v-else>
                            {{ item.license_plate }}
                          </template>
                        </span>

                        <span class="sp-p40 lineHide">
                          <template
                            v-if="
                              item.unit_short_name == undefined ||
                                item.unit_short_name.length == 0
                            "
                          >
                            --
                          </template>
                          <template v-else>
                            {{ item.unit_short_name }}
                          </template>
                        </span>
                        <span class="sp-p40 lineHide">
                          {{ formatBookingTime(item.booking_day) }}
                          {{ item.begin_time }}至{{ item.end_time }}
                        </span>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                </div>
              </div>
              <!-- 今日预约与进厂趋势对比统计 -->
              <div class="mainDivl-m-r-m2 mainDiv-br">
                <div class="title">今日预约与进厂趋势对比统计</div>
                <div class="echearDiv" ref="pieCanvas"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 今日、本周、当月、全年 -->
        <div class="mainDivr">
          <div class="titleDiv mainDiv-br">
            <div
              :class="
                'cpoint titleDiv1 ' + (dateSwitchActive == 1 ? 'active' : '')
              "
              @click="
                dateSwitchActiveEnd = false;
                dateSwitchActiveClick = true;
                dateSwitchActive = 1;
              "
            >
              今日
            </div>
            <div
              :class="
                'cpoint titleDiv2 ' + (dateSwitchActive == 2 ? 'active' : '')
              "
              @click="
                dateSwitchActiveEnd = false;
                dateSwitchActiveClick = true;
                dateSwitchActive = 2;
              "
            >
              本周
            </div>
            <div
              :class="
                'cpoint titleDiv3 ' + (dateSwitchActive == 3 ? 'active' : '')
              "
              @click="
                dateSwitchActiveEnd = false;
                dateSwitchActiveClick = true;
                dateSwitchActive = 3;
              "
            >
              当月
            </div>
            <div
              :class="
                'cpoint titleDiv4 ' + (dateSwitchActive == 4 ? 'active' : '')
              "
              @click="
                dateSwitchActiveEnd = false;
                dateSwitchActiveClick = true;
                dateSwitchActive = 4;
              "
            >
              全年
            </div>
          </div>
          <div class="mainDivr-m1">
            <p>
              <span>有效预约车次:</span>
              <span class="num1">
                {{ listNumWithTypeObj.booking_car_number }}
              </span>
              <span class="em"></span>
              <span>已发运车次:</span>
              <span class="num1">
                {{ listNumWithTypeObj.delivery_car_number }}
              </span>
            </p>
            <p>
              <span>完成度:</span>
              <span class="num2">{{ completePrec }}%</span>
            </p>
          </div>
          <div class="mainDivr-m2">
            <div class="title">成品装车效率</div>
            <div class="barCanvas1Div">
              <div class="barCanvas1">
                <div style="width:100%;height:100%;" ref="barCanvas1"></div>
                <img
                  v-if="Bar1pieData.length > 0"
                  class="anpng"
                  :src="anPng"
                  alt
                />
              </div>
              <div class="colorlist1">
                <div
                  class="colorlistItem"
                  v-for="(item, index) in Bar1pieData"
                  :key="index"
                >
                  <span
                    class="icon"
                    :style="'background-color:' + item.color + ';'"
                  ></span>
                  <span class="text lineHide"
                    >{{ item.value }}车次,{{ item.name }}</span
                  >
                </div>
              </div>
            </div>
            <div class="emptyData" v-if="Bar1pieData.length == 0">
              <span>暂无数据</span>
            </div>
          </div>
          <div class="mainDivr-m3">
            <div class="title">成品车辆单位分布</div>
            <div class="barCanvas2Div">
              <div class="barCanvas2">
                <div style="width:100%;height:100%;" ref="barCanvas2"></div>
                <img
                  v-if="Bar2pieData.length > 0"
                  class="anpng"
                  :src="anPng"
                  alt
                />
              </div>
              <div class="colorlist2">
                <div
                  class="colorlistItem"
                  v-for="(item, index) in Bar2pieData"
                  :key="index"
                >
                  <span
                    class="icon"
                    :style="'background-color:' + item.color + ';'"
                  ></span>
                  <span class="text lineHide"
                    >{{ item.value }}车次,{{ item.name }}</span
                  >
                </div>
              </div>
            </div>
            <div class="emptyData" v-if="Bar2pieData.length == 0">
              <span>暂无数据</span>
            </div>
          </div>
          <div class="mainDivr-m4 mainDiv-br">
            <div class="title">
              <span>装车后滞留车辆:</span>
              <span class="num">{{ listStrandedCarObj.count }}</span>
            </div>
            <div class="datahead">
              <span class="sp1">车牌号</span>
              <span class="sp2">物流单位</span>
              <span class="sp3">产品线</span>
              <span class="sp4">滞留时间</span>
            </div>
            <vue-seamless-scroll
              :data="listStrandedCarObj.items"
              :class-option="optionButtom4"
              ref="listStrandedCarObjElement"
              @ScrollEnd="listStrandedCarSroolEndFun"
              class="datarowDiv"
            >
              <div
                v-for="(item, index) in listStrandedCarObj.items"
                :key="index"
              >
                <div class="datarow">
                  <span class="sp1 lineHide">
                    <template
                      v-if="
                        item.license_plate == undefined ||
                          item.license_plate.length == 0
                      "
                      >--</template
                    >
                    <template v-else>{{ item.license_plate }}</template>
                  </span>
                  <span class="sp2 lineHide">
                    <template
                      v-if="
                        item.unit_short_name == undefined ||
                          item.unit_short_name.length == 0
                      "
                      >--</template
                    >
                    <template v-else>{{ item.unit_short_name }}</template>
                  </span>
                  <span class="sp3 lineHide">{{
                    businessNameText(item.business)
                  }}</span>
                  <span class="sp4 lineHide">
                    <template
                      v-if="
                        item.stranded_time == undefined ||
                          item.stranded_time.length == 0
                      "
                      >--</template
                    >
                    <template v-else>{{
                      minNumTotext(item.stranded_time)
                    }}</template>
                  </span>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
    <pagebutton></pagebutton>
  </section>
</template>

<script>
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
// import vueSeamlessScroll from "vue-seamless-scroll";
import vueSeamlessScroll from "@/components/vue-seamless-scroll-Plus/myClass.vue"; // vue-seamless-scroll修改版本
import pagebutton from "./pagebutton.vue"; //
export default {
  data() {
    return {
      deviceId: "",
      socketConnetMixinRoom: "ROOM_DELIVERY", //socketConnetMixin 加入对应的房间
      socketConnetMixinUnGetToken: true,
      autoReloadPage: true,
      tittlePng: require("./assets/img/tittle.png"),
      anPng: require("./assets/img/an.gif"),
      com_id: "",
      business_id: "",
      begin_date: "",
      end_date: "",
      AudioPaly: "",
      monitorList: [1, 1, 1, 1, 1],
      show_monitor: false,
      colorList: ["#00dcda", "#00e08e", "#cdca56", "#ff9f78", "#0091fa"],
      changeComidInterval: null,
      leaveAndStrandlistInterval: null,
      tabSwitchInterval: null,
      dateSwitchInterval: null,
      tabSwitchActive: 1,
      dateSwitchActive: 0,
      tabSwitchActiveEnd: false,
      dateSwitchActiveEnd: false,
      tabSwitchActiveClick: false,
      dateSwitchActivClick: false,
      comInfoObj: {},
      listWarehouseObj: {
        total_parking: 0,
        in_busy: 0,
        in_idle: 0,
        warehouse: []
      },
      listCarNumberObj: {
        not_info_car_number: 0,
        queuing_car_number: 0,
        call_car_number: 0,
        loading_car_number: 0
      },
      listLeaveCarObj: {},
      listLeaveCarSroolEnd: false,
      listStrandedCarObj: {},
      listStrandedCarSroolEnd: false,
      listLoadingCarDroom: { items: [] },
      callingItems: [],
      loadingItems: [],
      listLoadingCarDroomLoadEnd: false,
      listQueueCarDroom: { items: [] },
      listReportCarDroom: { items: [] }, // 报道中
      listUnApproachCarDroom: { items: [] }, // 未进厂
      trendBookingCarObj: {},
      listNumWithTypeObj: {},
      Bar1pieData: [],
      Bar2pieData: [],
      comList: [],
      activeComeIndex: 0
    };
  },
  watch: {
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        console.log("获取业务数据");
        if (this.comList.length == 0) {
          let comListRes = await this.getComList();
          this.comList = comListRes.data.data;
          // 根据url的comId判断显示厂区的数据
          let com_id = this.$route.query.com_id;
          this.comList.forEach((item, index) => {
            if (com_id == item.id) {
              this.activeComeIndex = index;
            }
          });
          this.comInfoObj = {
            business: [],
            com_info: this.comList[this.activeComeIndex]
          };
          this.com_id = this.comList[this.activeComeIndex].id;
        }
        this.listCarNumber();
        this.listWarehouse();
        this.listStrandedCar();
        this.listLeaveCar();
        this.listLoadingCarDroomObj();
        this.listQueueCarDroomObj();
        this.listReportCarDroomObj(); // 报道中
        this.listUnApproachCarDroomObj(); // 未进厂
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      const evenQueue = JSON.parse(val);
      console.warn("socket数据来", evenQueue);
      this.changeAllObj(evenQueue);
    },
    callingItems() {
      this.setlistLoadingCarDroomItems();
    },
    loadingItems() {
      this.setlistLoadingCarDroomItems();
    },
    dateSwitchActive(val) {
      this.listNumWithType(val);
      this.countLoadingTimeWithType(val);
      this.countUnitCarWithType(val);
    },
    com_id(_n, _o) {
      console.error("切换厂区------------", this.comInfoObj);
      // 清除定时器
      window.clearInterval(this.dateSwitchInterval);
      window.clearInterval(this.tabSwitchInterval);
      this.dateSwitchInterval = 0;
      this.tabSwitchInterval = 0;
      // 调整显示第一个
      this.tabSwitchActive = 1;
      this.tabSwitchActiveEnd = false;
      // 调整显示第一个
      if (this.dateSwitchActive == 1) {
        this.listNumWithType(1);
        this.countLoadingTimeWithType(1);
        this.countUnitCarWithType(1);
        this.dateSwitchActiveEnd = false;
      } else {
        this.dateSwitchActive = 1;
        this.dateSwitchActiveEnd = false;
      }
      // 关闭Socket，重连完成切换厂区
      if (_o.length > 0 && _n.length > 0) {
        // 第一次不执行操作
        this.closeSocket();
        setTimeout(() => {
          this.initSocket();
        }, 100);
      }
      // 折线图
      // 加载其他数据
      this.creatLineChart();
      // this.leaveAndStrandlistInterval = window.setInterval(() => {
      //   this.creatLineChart();
      // }, 8 * 1000);

      // 装车中和排队中切换
      this.tabSwitchInterval = window.setInterval(() => {
        // 大于15秒滚动完
        let isMoveing = true;
        console.log(12312321321, this.listLoadingCarDroom.items.length);
        if (
          this.tabSwitchActive == 1 &&
          this.listLoadingCarDroom.items &&
          this.listLoadingCarDroom.items.length < 8
        ) {
          isMoveing = false;
        }

        console.log(isMoveing);
        console.log(12312321321, this.listQueueCarDroom.items.length);
        if (
          this.tabSwitchActive == 2 &&
          this.listQueueCarDroom.items &&
          this.listQueueCarDroom.items.length < 8
        ) {
          isMoveing = false;
        }

        if (
          this.tabSwitchActive == 3 &&
          this.listReportCarDroom.items &&
          this.listReportCarDroom.items.length < 8
        ) {
          isMoveing = false;
        }

        if (
          this.tabSwitchActive == 4 &&
          this.listUnApproachCarDroom.items &&
          this.listUnApproachCarDroom.items.length < 8
        ) {
          isMoveing = false;
        }

        if (!isMoveing || this.listLoadingCarDroomLoadEnd) {
          this.listLoadingCarDroomLoadEnd = false;
          if (this.tabSwitchActive == 1) {
            if (this.$refs.listLoadingCarDroomElement != undefined) {
              this.$refs.listLoadingCarDroomElement.removeSingleWaitTime();
            }
            this.tabSwitchActive = 2;
            this.$nextTick(() => {
              this.$refs.listQueueCarDroomElement.reset();
            });
          } else if (this.tabSwitchActive == 2) {
            if (this.$refs.listQueueCarDroomElement != undefined) {
              this.$refs.listQueueCarDroomElement.removeSingleWaitTime();
            }
            this.tabSwitchActive = 3;
            this.$nextTick(() => {
              this.$refs.listReportCarDroomElement.reset();
            });
            if (!this.tabSwitchActiveClick) {
              this.tabSwitchActiveEnd = true;
            } else {
              this.tabSwitchActiveClick = false;
            }
          } else if (this.tabSwitchActive == 3) {
            if (this.$refs.listReportCarDroomElement != undefined) {
              this.$refs.listReportCarDroomElement.removeSingleWaitTime();
            }
            this.tabSwitchActive = 4;
            this.$nextTick(() => {
              this.$refs.listUnApproachCarDroomElement.reset();
            });
            if (!this.tabSwitchActiveClick) {
              this.tabSwitchActiveEnd = true;
            } else {
              this.tabSwitchActiveClick = false;
            }
          } else if (this.tabSwitchActive == 4) {
            if (this.$refs.listUnApproachCarDroomElement != undefined) {
              this.$refs.listUnApproachCarDroomElement.removeSingleWaitTime();
            }
            this.tabSwitchActive = 1;
            this.$nextTick(() => {
              this.$refs.listLoadingCarDroomElement.reset();
            });
            if (!this.tabSwitchActiveClick) {
              this.tabSwitchActiveEnd = true;
            } else {
              this.tabSwitchActiveClick = false;
            }
          } else {
            console.log(123213);
          }
        }
      }, 30 * 1000);

      // 右侧时间切换以及定时刷新
      this.dateSwitchActive = 1;
      this.dateSwitchInterval = window.setInterval(() => {
        if (this.dateSwitchActive < 4) {
          this.dateSwitchActive++;
        } else {
          this.dateSwitchActive = 1;
          if (!this.dateSwitchActiveClick) {
            this.dateSwitchActiveEnd = true;
          } else {
            this.dateSwitchActiveClick = false;
          }
        }
        this.listStrandedCarReload();
        this.listLeaveCarReload();
      }, 60 * 1000);
    }
  },
  computed: {
    posLeftSt() {
      return {
        width: this.show_monitor ? `18.75%` : `0`
      };
    },
    posRightSt() {
      return {
        width: this.show_monitor ? `calc(100% - 18.75%)` : `100%`
      };
    },
    optionButtom1() {
      let limitMoveNum = 1;
      this.listWarehouseObj.warehouse.forEach(item => {
        if (item.location.length < 3) {
          limitMoveNum++;
        }
      });
      limitMoveNum = 1;
      return {
        limitMoveNum: limitMoveNum,
        step: 0.5,
        hoverStop: false
      };
    },
    optionButtom2() {
      return {
        limitMoveNum: 6,
        step: 0.5,
        hoverStop: false
      };
    },
    optionButtom3() {
      return {
        limitMoveNum: 8,
        step: 0.5,
        hoverStop: false
      };
    },
    optionButtom4() {
      return {
        limitMoveNum: 2,
        step: 0.5,
        hoverStop: false
      };
    },
    businessNameText() {
      return business => {
        if (!(business instanceof Array)) {
          return "";
        }
        let businessTextArr = [];
        business.forEach(item => {
          businessTextArr.push(item.name);
        });
        let businessText = "--";
        if (businessTextArr.length > 0) {
          businessText = businessTextArr.join("、");
          if (businessTextArr.length > 1) {
            businessText = businessText.slice(0, businessText.length - 1);
          }
        }
        return businessText;
      };
    },
    queueStateTextColor() {
      return state => {
        if (state == 1) {
          return "c-ffda3e";
        }
        if (state == 2) {
          return "c-f8375a";
        }
        if (state == 3) {
          return "c-1890ff";
        }
        return "";
      };
    },
    completePrec() {
      let prec = 0;
      if (
        Number(this.listNumWithTypeObj.delivery_car_number) > 0 &&
        Number(this.listNumWithTypeObj.booking_car_number) > 0
      ) {
        prec = (
          Number(
            (
              this.listNumWithTypeObj.delivery_car_number /
              this.listNumWithTypeObj.booking_car_number
            ).toFixed(2)
          ) * 100
        ).toFixed(0);
      }
      return prec;
    }
  },
  components: { vueSeamlessScroll, pagebutton },
  mixins: [socketConnetMixin, socketListStoreMixin, socketListComputedMixin],
  async mounted() {
    this.changeComidInterval = window.setInterval(() => {
      if (this.tabSwitchActiveEnd && this.dateSwitchActiveEnd) {
        this.activeComeIndex = this.activeComeIndex + 1;
        if (this.activeComeIndex > this.comList.length - 1) {
          this.activeComeIndex = 0;
        }
        this.comInfoObj = {
          business: [],
          com_info: this.comList[this.activeComeIndex]
        };
        // 走页面跳转，修复
        let query = this.$route.query;
        query.token = `share-${this.comList[this.activeComeIndex].id}`;
        query.com_id = this.comList[this.activeComeIndex].id;
        let queryArr = [];
        for (const key in query) {
          queryArr.push(`${key}=${query[key]}`);
        }
        this.closeSocket();
        let newUrl = location.href.split("?")[0] + `?${queryArr.join("&")}`;
        console.log(newUrl);
        this.$router.push({
          path: "/rhBigScreen/redirectPage",
          query: {
            redirect_url: encodeURIComponent(newUrl)
          }
        });
        // this.com_id = this.comList[this.activeComeIndex].id;
      }
    }, 5 * 1000);
    // // 折线图
    // this.creatLineChart();
    // // this.leaveAndStrandlistInterval = window.setInterval(() => {
    // //   this.creatLineChart();
    // // }, 8 * 1000);
    // // 装车中和排队中切换
    // this.tabSwitchInterval = window.setInterval(() => {
    //   // 大于15秒滚动完
    //   let isMoveing = true;
    //   console.log(12312321321, this.listLoadingCarDroom.items.length);
    //   if (
    //     this.tabSwitchActive == 1 &&
    //     this.listLoadingCarDroom.items &&
    //     this.listLoadingCarDroom.items.length < 8
    //   ) {
    //     isMoveing = false;
    //   }
    //   console.log(isMoveing);
    //   console.log(12312321321, this.listQueueCarDroom.items.length);
    //   if (
    //     this.tabSwitchActive == 2 &&
    //     this.listQueueCarDroom.items &&
    //     this.listQueueCarDroom.items.length < 8
    //   ) {
    //     isMoveing = false;
    //   }
    //   if (!isMoveing || this.listLoadingCarDroomLoadEnd) {
    //     this.listLoadingCarDroomLoadEnd = false;
    //     if (this.tabSwitchActive == 1) {
    //       if (this.$refs.listLoadingCarDroomElement != undefined) {
    //         this.$refs.listLoadingCarDroomElement.removeSingleWaitTime();
    //       }
    //       this.tabSwitchActive = 2;
    //       this.$nextTick(() => {
    //         this.$refs.listQueueCarDroomElement.reset();
    //       });
    //     } else if (this.tabSwitchActive == 2) {
    //       if (this.$refs.listQueueCarDroomElement != undefined) {
    //         this.$refs.listQueueCarDroomElement.removeSingleWaitTime();
    //       }
    //       this.tabSwitchActive = 1;
    //       this.$nextTick(() => {
    //         this.$refs.listLoadingCarDroomElement.reset();
    //       });
    //       this.tabSwitchActiveEnd = true;
    //     } else {
    //       console.log("log");
    //     }
    //   }
    // }, 15 * 1000);
    // // 右侧时间切换以及定时刷新
    // this.dateSwitchActive = 1;
    // this.dateSwitchInterval = window.setInterval(() => {
    //   if (this.dateSwitchActive < 4) {
    //     this.dateSwitchActive++;
    //   } else {
    //     this.dateSwitchActive = 1;
    //     this.dateSwitchActiveEnd = true;
    //   }
    //   this.listStrandedCarReload();
    //   this.listLeaveCarReload();
    // }, 60 * 1000);
  },
  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.changeComidInterval);
    window.clearInterval(this.leaveAndStrandlistInterval);
    window.clearInterval(this.dateSwitchInterval);
    window.clearInterval(this.tabSwitchInterval);
    next();
  },
  async created() {
    // this.com_id = this.$route.query.com_id;
    this.business_id = this.$route.query.business_id || "";
    this.AudioPaly = this.$route.query.audio_paly == 1 ? true : false;
    this.show_monitor = this.$route.query.show_monitor == 1 ? true : false;

    // let comListRes = await this.getComList();
    // this.comList = comListRes.data.data;
    // this.activeComeIndex = 0;
    // this.comInfoObj = {
    //   business: [],
    //   com_info: this.comList[this.activeComeIndex]
    // };
    // this.com_id = this.comList[this.activeComeIndex].id;

    // 模拟厂区切换
    // setTimeout(() => {
    //   this.tabSwitchActiveEnd = true;
    //   this.dateSwitchActiveEnd = true;
    //   setTimeout(() => {
    //     this.tabSwitchActiveEnd = true;
    //     this.dateSwitchActiveEnd = true;
    //   }, 15000);
    // }, 15000);

    // this.getComInfo();
    // this.getComInfo();
    // this.listCarNumber();
    // this.listWarehouse();
    // this.listStrandedCar();
    // this.listLeaveCar();
    // this.listLoadingCarDroomObj();
    // this.listQueueCarDroomObj();
  },
  methods: {
    getComList() {
      return this.$common.http({
        method: "post",
        url: "/api/queue/summary/list_com"
      });
    },
    playScrollEnd() {
      console.log("滚动完了");
      this.listLoadingCarDroomLoadEnd = true;
    },
    setlistLoadingCarDroomItems() {
      this.listLoadingCarDroom.items = this.loadingItems.concat(
        this.callingItems
      );
      this.$nextTick(() => {
        if (this.tabSwitchActive == 1) {
          this.$refs.listLoadingCarDroomElement.reset();
        }
        if (this.tabSwitchActive == 2) {
          this.$refs.listQueueCarDroomElement.reset();
        }
      });
    },
    // 处理socket数据
    changeAllObj({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.business_id,
          "变更数据id：" + data.business_id
        );

        console.log("操作数据");
        // 刷新车辆汇总数
        if (element.queue == "ACTION_REFRESH_NUMBER") {
          this.listCarNumber();
        }
        // 刷新趋势
        if (element.queue == "ACTION_REFRESH_TREND") {
          this.creatLineChart();
        }
        // 更新装车位
        if (
          element.queue == "ACTION_OCCUPY_WAREHOUSE" ||
          element.queue == "ACTION_RELEASE_WAREHOUSE" ||
          element.queue == "ACTION_REFRESH_NUMBER"
        ) {
          this.listWarehouse();
        }

        // 产品线屏幕时,只处理当前产品线的数据
        if (
          this.business_id.length > 0 &&
          data.business_id != this.business_id
        ) {
          return;
        }
        // 叫号中-正在叫号
        if (element.queue == "QUEUE_CALLING") {
          let tmpCallingItems = JSON.parse(JSON.stringify(this.callingItems));
          this.callingItems = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingItems
          );
        }
        // 叫号中-装车中
        if (element.queue == "QUEUE_LOADING") {
          let tmpLoadingItems = JSON.parse(JSON.stringify(this.loadingItems));
          this.loadingItems = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingItems
          );
        }
        // 排队中
        if (element.queue == "QUEUE_QUEUE") {
          let tmpqueuingItems = JSON.parse(
            JSON.stringify(this.listQueueCarDroom.items)
          );
          this.listQueueCarDroom.items = this.reSetListBySocket(
            element.action,
            data,
            tmpqueuingItems
          );
        }
        // 已报到
        if (element.queue == "QUEUE_REPORTED") {
          let tmpqueuingItems = JSON.parse(
            JSON.stringify(this.listReportCarDroom.items)
          );
          this.listReportCarDroom.items = this.reSetListBySocket(
            element.action,
            data,
            tmpqueuingItems
          );
        }
        // 未进厂
        if (element.queue == "QUEUE_NOT_INTO_FACTORY") {
          let tmpqueuingItems = JSON.parse(
            JSON.stringify(this.listUnApproachCarDroom.items)
          );
          this.listUnApproachCarDroom.items = this.reSetListBySocket(
            element.action,
            data,
            tmpqueuingItems
          );
        }
      });
    },
    getBarOption2(resData) {
      let legendData = [];
      let pieData = [];
      resData.forEach(item => {
        if (Number(item.car_number) > 0) {
          legendData.push(item.short_name);
          pieData.push({ value: item.car_number, name: item.short_name });
          // 设置颜色
          for (let i = 0; i < pieData.length; i++) {
            if (i < this.colorList.length) {
              pieData[i].color = this.colorList[i];
            } else {
              let ci = i % this.colorList.length;
              pieData[i].color = this.colorList[ci];
            }
          }
        }
      });
      this.Bar2pieData = pieData;
      return {
        series: [
          {
            type: "pie",
            radius: ["47%", "78%"],
            center: ["46%", "48%"],
            hoverOffset: 0,
            selectedOffset: 0,
            bottom: 0,
            data: pieData,
            label: {
              formatter: "{b}\n{c}车次",
              fontSize: 17,
              show: false
            },
            itemStyle: {
              normal: {
                color: params => {
                  return params.data.color;
                }
              }
            }
          }
        ]
      };
    },
    getBarOption1(resData) {
      let legendData = [];
      let pieData = [];
      Object.keys(resData.items).forEach(key => {
        if (Number(resData.items[key]) > 0) {
          let name = "";
          if (key == "<1800") {
            name = "小于0.5小时";
          }
          if (key == "1800~3600") {
            name = "0.5~1小时";
          }
          if (key == "3600~7200") {
            name = "1~2小时";
          }
          if (key == "7200~10800") {
            name = "2~3小时";
          }
          if (key == ">=10800") {
            name = "大于3小时";
          }
          legendData.push(name);
          pieData.push({ value: resData.items[key], name });
          // 设置颜色
          for (let i = 0; i < pieData.length; i++) {
            if (i < this.colorList.length) {
              pieData[i].color = this.colorList[i];
            } else {
              let ci = i % this.colorList.length;
              pieData[i].color = this.colorList[ci];
            }
          }
        }
      });
      this.Bar1pieData = pieData;
      return {
        series: [
          {
            type: "pie",
            radius: ["47%", "78%"],
            center: ["46%", "48%"],
            hoverOffset: 0,
            selectedOffset: 0,
            bottom: 0,
            data: pieData,
            label: {
              formatter: "{b}\n{c}车次",
              fontSize: 17,
              show: false
            },
            itemStyle: {
              normal: {
                color: params => {
                  return params.data.color;
                }
              }
            }
          }
        ]
      };
    },
    getPeiOption({ booking, info, scale }) {
      let xAxisData = [];
      let seriesData1 = [];
      let seriesData2 = [];
      scale.forEach(item => {
        xAxisData.push(item.slice(0, 2) + ":" + item.slice(2, 4));
        seriesData1.push(booking[item]);
        seriesData2.push(info[item]);
      });
      let option = {
        color: ["#FFA173", "#005786"],
        legend: {
          data: [
            {
              name: "实际进厂车次",
              icon: "circle"
            },
            {
              name: "预约进厂车次",
              icon: "circle"
            }
          ],
          textStyle: {
            color: "rgba(255,255,255,0.80)"
          },
          top: 15
        },
        tooltip: {
          axisPointer: {
            animation: false
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: xAxisData,
            axisLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.80)"
              }
            },
            axisLabel: {
              color: "rgba(255,255,255,0.80)"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 1,
            axisLabel: {
              color: "rgba(255,255,255,0.80)"
            },
            axisLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.80)"
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "实际进厂车次",
            type: "line",
            areaStyle: {},
            // data: seriesData1,
            data: seriesData2,
            smooth: true,
            symbolSize: 1
          },
          {
            name: "预约进厂车次",
            type: "line",
            areaStyle: {},
            // data: seriesData2,
            data: seriesData1,
            smooth: true,
            symbolSize: 1
          }
        ]
      };
      console.log(JSON.stringify(option));
      return option;
    },
    // 获取产区信息
    getComInfo() {
      this.$common
        .http({
          url: "/api/queue/summary/com_info",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.comInfoObj = res.data.data;
        });
    },
    // 仓库位置
    listWarehouse() {
      this.$common
        .http({
          url: "/api/queue/summary/list_warehouse",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          let listWarehouseObj = res.data.data;
          let warehouse = [];
          listWarehouseObj.warehouse.forEach(element => {
            if (element.location && element.location.length > 0) {
              warehouse.push(element);
            }
          });
          listWarehouseObj.warehouse = warehouse;
          this.listWarehouseObj = listWarehouseObj;
        });
    },
    // 车辆统计
    listCarNumber() {
      this.$common
        .http({
          url: "/api/queue/summary/list_car_number",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.listCarNumberObj = res.data.data;
          // console.warn(res);
        });
    },
    // 滞留车辆
    listStrandedCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_stranded_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.listStrandedCarObj = res.data.data;
        });
    },
    // 发运车辆
    listLeaveCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_leave_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.listLeaveCarObj = res.data.data;
        });
    },
    // 已报到车辆列表
    listReportCarDroomObj() {
      this.$common
        .http({
          url: "/api/queue/summary/list_reported_car_droom",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          let itemData = res.data.data;
          let response_time = res.data.data.response_time;
          itemData.items.forEach(item => {
            item.response_time = response_time;
            // item.id = item.queue_id;
          });
          this.listReportCarDroom = itemData;
        });
    },
    // 未进厂车辆列表
    listUnApproachCarDroomObj() {
      this.$common
        .http({
          url: "/api/queue/summary/list_not_into_car_droom",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          let itemData = res.data.data;
          let response_time = res.data.data.response_time;
          itemData.items.forEach(item => {
            item.response_time = response_time;
            // item.id = item.queue_id;
          });
          this.listUnApproachCarDroom = itemData;
        });
    },
    // 排队中车辆列表
    listQueueCarDroomObj() {
      this.$common
        .http({
          url: "/api/queue/summary/list_queue_car_droom",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          let itemData = res.data.data;
          let response_time = res.data.data.response_time;
          itemData.items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          this.listQueueCarDroom = itemData;
        });
    },
    // 装车中车辆列表
    listLoadingCarDroomObj() {
      this.$common
        .http({
          url: "/api/queue/summary/list_loading_car_droom",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          let loading_items = res.data.data.loading_items;
          let calling_items = res.data.data.calling_items;
          let response_time = res.data.data.response_time;
          loading_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          calling_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          this.loadingItems = loading_items;
          this.callingItems = calling_items;

          // this.listLoadingCarDroom.items = this.listLoadingCarDroom.loading_items;
        });
    },
    // 预约与进厂趋势对比数据
    trendBookingCar() {
      return this.$common.http({
        url: "/api/queue/summary/trend_booking_car",
        data: {
          com_id: this.com_id,
          business_id: this.business_id
        },
        noLoading: true
      });
    },
    async creatLineChart() {
      const trendBookingCarRest = await this.trendBookingCar();
      let option = this.getPeiOption(trendBookingCarRest.data.data);
      let pieEl = null;
      if (!pieEl) {
        pieEl = this.$echarts.init(this.$refs.pieCanvas);
      }
      pieEl.setOption(option, true);
    },
    listNumWithType(type) {
      this.$common
        .http({
          url: "/api/queue/summary/list_num_with_type",
          data: {
            com_id: this.com_id,
            business_id: this.business_id,
            type: type
          },
          noLoading: true
        })
        .then(res => {
          this.listNumWithTypeObj = res.data.data;
        });
    },
    countLoadingTimeWithType(type) {
      this.$common
        .http({
          url: "/api/queue/summary/count_loading_time_with_type",
          data: {
            com_id: this.com_id,
            business_id: this.business_id,
            type: type
          },
          noLoading: true
        })
        .then(res => {
          let optionbar1 = this.getBarOption1(res.data.data);
          let barEl1 = null;
          if (!barEl1) {
            barEl1 = this.$echarts.init(this.$refs.barCanvas1);
          }
          barEl1.setOption(optionbar1, true);
        });
    },
    countUnitCarWithType(type) {
      this.$common
        .http({
          url: "/api/queue/summary/count_unit_car_with_type",
          data: {
            com_id: this.com_id,
            business_id: this.business_id,
            type: type
          },
          noLoading: true
        })
        .then(res => {
          let optionbar1 = this.getBarOption2(res.data.data.items);
          let barEl1 = null;
          if (!barEl1) {
            barEl1 = this.$echarts.init(this.$refs.barCanvas2);
          }
          barEl1.setOption(optionbar1, true);
        });
    },
    listLeaveCarSroolEndFun() {
      this.listLeaveCarSroolEnd = true;
    },
    listLeaveCarReload() {
      if (this.listLeaveCarObj.items && this.listLeaveCarObj.items.length < 5) {
        this.listLeaveCarSroolEnd = true;
      }
      if (this.listLeaveCarSroolEnd) {
        this.listLeaveCar();
        this.listLeaveCarSroolEnd = false;
      }
    },
    listStrandedCarSroolEndFun() {
      this.listStrandedCarSroolEnd = true;
    },
    listStrandedCarReload() {
      if (
        this.listStrandedCarObj.items &&
        this.listStrandedCarObj.items.length < 3
      ) {
        this.listStrandedCarSroolEnd = true;
      }

      if (this.listStrandedCarSroolEnd) {
        this.listStrandedCar();
        this.listStrandedCarSroolEnd = true;
      }
    },
    manualChangeComId() {
      this.activeComeIndex = this.activeComeIndex + 1;
      if (this.activeComeIndex > this.comList.length - 1) {
        this.activeComeIndex = 0;
      }
      this.comInfoObj = {
        business: [],
        com_info: this.comList[this.activeComeIndex]
      };
      // 走页面跳转,修复
      let query = this.$route.query;
      query.token = `share-${this.comList[this.activeComeIndex].id}`;
      query.com_id = this.comList[this.activeComeIndex].id;
      let queryArr = [];
      for (const key in query) {
        queryArr.push(`${key}=${query[key]}`);
      }
      this.closeSocket();
      let newUrl = location.href.split("?")[0] + `?${queryArr.join("&")}`;
      console.log(newUrl);
      this.$router.push({
        path: "/rhBigScreen/redirectPage",
        query: {
          redirect_url: encodeURIComponent(newUrl)
        }
      });
      // this.com_id = this.comList[this.activeComeIndex].id;
      // if (this.dateSwitchActive == 1) {
      //   this.listNumWithType(1);
      //   this.countLoadingTimeWithType(1);
      //   this.countUnitCarWithType(1);
      // }
    }
  }
};
</script>
<style lang="less" scoped>
.IndexShipmentlLeader {
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  background-color: #00305f;
  overflow: hidden;
  .cpoint {
    cursor: pointer;
  }
  .c-ffda3e {
    color: #ffda3e;
  }
  .c-f8375a {
    color: #f8375a;
  }
  .c-1890ff {
    color: #1890ff;
  }
  .lineHide {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // text-align: left !important;
  }
  p {
    margin: 0;
  }
  .mainDiv-br {
    border: 2px solid #078cc8;
    border-radius: 2px 2px 0 0;
  }
  .left {
    height: 100%;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    padding-top: 120px;
    > div {
      width: 100%;
      height: 161px;
      margin-top: 20px;
    }
  }
  .right {
    height: 100%;
    position: relative;
    .tittleP {
      font-size: 42px;
      text-align: center;
      background-image: -webkit-linear-gradient(top, #24d7fc, #24d7fc, #ffffff);
      background-clip: text;
      -webkit-text-fill-color: transparent;
      position: absolute;
      width: 100%;
      top: 3px;
      line-height: 59px;
      .manualChangeComId {
        cursor: pointer;
      }
    }
    .titleTime {
      position: absolute;
      font-size: 20px;
      text-align: center;
      background-image: -webkit-linear-gradient(top, #24d7fc, #24d7fc, #ffffff);
      background-clip: text;
      -webkit-text-fill-color: transparent;
      position: absolute;
      top: -15px;
      right: 18px;
      line-height: 84px;
    }
    .tittlePng {
      width: 100%;
      height: 160px;
    }
    .mainDiv {
      display: flex;
      height: calc(100% - 84px);
      width: 100%;
      position: relative;
      top: -77px;
    }
    .mainDivl {
      width: calc(100% - 488px);
    }
    .mainDivl-title {
      font-size: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45px;
      line-height: 45px;
      color: #078cc8;
      padding-top: 3px;
      padding-bottom: 17px;
      .text {
        padding-right: 10px;
      }
      .num1 {
        color: #ffffff;
        font-size: 56px;
        margin-right: 20px;
      }
      .num2 {
        color: #ffffff;
        font-size: 50px;
        margin-right: 20px;
      }
      .lineColumn {
        height: 100%;
        width: 2px;
        margin-right: 20px;
        background-image: linear-gradient(
          180deg,
          #00305f 0%,
          #00d0df 47%,
          #00305f 100%
        );
      }
    }

    .mainDivl-m {
      width: 100%;
      display: flex;
      height: calc(100% - 50px);
      padding-left: 5px;
      box-sizing: border-box;
      .mainDivl-m-l {
        width: 400px;
        padding-right: 10px;
        .mainDivl-m-l-m1 {
          height: 190px;
          > div {
            padding-left: 50px;
          }
          .title {
            font-size: 28px;
            color: rgba(255, 255, 255, 0.8);
            background-image: linear-gradient(
              180deg,
              #00305f 0%,
              rgba(7, 140, 200, 0.05) 100%
            );
            border-top: 2px solid #078cc8;
            line-height: 59px;
            display: flex;
            align-items: center;
            span {
              display: inline-block;
            }
            .num {
              color: #fff;
              font-size: 56px;
            }
          }
          .working {
            font-size: 26px;
            color: #ffffff;
            line-height: 30px;
            display: flex;
            align-items: center;
            line-height: 59px;
            .icon {
              display: inline-block;
              background: #ffa173;
              border-radius: 2px;
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }
            .num {
              color: #ffa173;
            }
          }

          .emptying {
            font-size: 26px;
            color: #ffffff;
            line-height: 30px;
            display: flex;
            align-items: center;
            line-height: 59px;
            .icon {
              display: inline-block;
              background: #00cece;
              border-radius: 2px;
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }
            .num {
              color: #00cece;
            }
          }
        }
        .mainDivl-m-l-m2 {
          height: 323px;
          background-image: linear-gradient(
            180deg,
            #00305f 0%,
            rgba(7, 140, 200, 0.04) 100%
          );
          border-top: 2px solid #078cc8;
          overflow: hidden;
          .title {
            font-size: 28px;
            color: rgba(255, 255, 255, 0.8);
            text-align: center;
            line-height: 60px;
            margin-bottom: 10px;
          }
          .carStateDiv {
            display: flex;
            flex-flow: row wrap;
            align-content: flex-start;
            .carState {
              width: 33%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              padding-bottom: 20px;
              span {
                display: inline-block;
              }
              .working {
                background: #04dbdb;
                width: 52px;
                height: 52px;
              }
              .workingText {
                padding-top: 10px;
                color: #04dbdb;
              }
              .emptying {
                background: #ffa173;
                width: 52px;
                height: 52px;
              }
              .emptyingText {
                padding-top: 10px;
                color: #ffa173;
              }
            }
          }
        }
        .mainDivl-m-l-m3 {
          height: 363px;
          margin-top: 6px;
          .title {
            background: #00579c;
            font-size: 24px;
            color: #04dbdb;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 59px;
            .num {
              font-size: 36px;
              color: rgba(255, 255, 255, 0.8);
              letter-spacing: 0.95px;
            }
          }
          .datahead {
            display: flex;
            font-size: 20px;
            color: #078cc8;
            line-height: 45px;
            span {
              text-align: center;
            }
            .sp1 {
              width: 33.3%;
            }
            .sp2 {
              width: 33.3%;
            }
            .sp3 {
              width: 33.3%;
            }
          }
          .datarowDiv {
            height: calc(100% - 45px - 59px);
            overflow: hidden;
          }
          .datarow {
            font-size: 22px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 55px;
            display: flex;
            span {
              text-align: center;
              display: inline-block;
              padding: 0 3px;
              box-sizing: border-box;
            }
            .sp1 {
              width: 33.3%;
            }
            .sp2 {
              width: 33.3%;
            }
            .sp3 {
              width: 33.3%;
            }
          }
        }
      }
      .mainDivl-m-r {
        width: calc(100% - 420px);
        padding-right: 10px;
        .mainDivl-m-r-m1 {
          height: 510px;
          .DataDiv {
            height: calc(100% - 60px);
          }
          .titleDiv {
            display: flex;
            height: 60px;
            font-size: 22px;
            border-bottom: 2px solid #00579c;
            color: #078cc8;
            .num {
              font-size: 36px;
            }
            .active {
              color: #04dbdb;
              background: #00579c;
              .num {
                color: #fff;
              }
            }
            .titleDivL {
              width: 50%;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .titleDivR {
              width: 50%;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .datahead {
            display: flex;
            font-size: 20px;
            color: #078cc8;
            line-height: 45px;
            span {
              text-align: center;
            }
            .sp-p17 {
              width: 17%;
            }
            .sp-p29 {
              width: 29%;
            }
            .sp-p27 {
              width: 27%;
            }
            .sp-p20 {
              width: 20%;
            }
            .sp-p40 {
              width: 40%;
            }
            .sp2 {
              width: 14%;
            }
            .sp3 {
              width: 23%;
            }
            .sp4 {
              width: 23%;
            }
            .sp5 {
              width: 23%;
            }
            .sp6 {
              width: 17%;
            }
            // .sp3_1 {
            //   width: 170px;
            //   padding-left: 5px;
            //   box-sizing: border-box;
            // }
            // .sp4_1 {
            //   width: 176px;
            //   padding-left: 5px;
            //   box-sizing: border-box;
            // }
            // .sp5_1 {
            //   width: 110px;
            // }
            // .sp6_1 {
            //   width: 141px;
            // }
          }
          .datarowDiv {
            height: calc(100% - 45px);
            overflow: hidden;
          }
          .datarow {
            font-size: 22px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 53px;
            display: flex;
            span {
              text-align: center;
            }
            .sp2 {
              width: 14%;
            }
            .sp3 {
              width: 23%;
              padding-left: 5px;
              box-sizing: border-box;
            }
            .sp4 {
              width: 23%;
              padding-left: 5px;
              box-sizing: border-box;
            }
            .sp5 {
              width: 23%;
            }
            .sp6 {
              width: 17%;
            }

            .sp-p17 {
              width: 17%;
            }
            .sp-p29 {
              width: 29%;
            }
            .sp-p27 {
              width: 27%;
            }
            .sp-p20 {
              width: 20%;
            }
            .sp-p40 {
              width: 40%;
            }
            // .sp3_1 {
            //   width: 170px;
            //   padding-left: 5px;
            //   box-sizing: border-box;
            // }
            // .sp4_1 {
            //   width: 176px;
            //   padding-left: 5px;
            //   box-sizing: border-box;
            // }
            // .sp5_1 {
            //   width: 110px;
            // }
            // .sp6_1 {
            //   width: 141px;
            // }
          }
        }
        .mainDivl-m-r-m2 {
          margin-top: 7px;
          height: 363px;
          .title {
            line-height: 60px;
            font-size: 26px;
            background: #00579c;
            color: #04dbdb;
            text-align: center;
          }
          .echearDiv {
            width: 100%;
            height: 308px;
          }
        }
      }
    }
    .mainDivr {
      width: 488px;
      height: 100%;
      padding-right: 15px;
      box-sizing: border-box;
      .titleDiv {
        display: flex;
        height: 60px;
        font-size: 22px;
        border-bottom: 2px solid #00579c;
        color: #078cc8;
        .titleDiv1,
        .titleDiv2,
        .titleDiv3,
        .titleDiv4 {
          width: 25%;
          line-height: 60px;
          text-align: center;
          border-right: 2px solid #00579c;
        }
        .active {
          color: #04dbdb;
          background: #00579c;
          .num {
            color: #fff;
          }
        }
        .titleDiv4 {
          border-right: none;
        }
      }
      .mainDivr-m1 {
        padding-top: 18px;
        p {
          font-size: 26px;
          line-height: 26px;
          padding-bottom: 20px;
          color: #078cc8;
          text-align: center;
          display: flex;
          align-items: center;
          span {
            display: inline-block;
          }
        }
        .em {
          display: inline-block;
          padding-right: 10px;
        }

        .num1 {
          font-size: 34px;
          color: #04dbdb;
        }
        .num2 {
          font-size: 46px;
          color: #ffa173;
        }
      }
      .mainDivr-m2 {
        position: relative;
        .title {
          font-size: 26px;
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          background-image: linear-gradient(
            180deg,
            #00305f 0%,
            rgba(7, 140, 200, 0.05) 100%
          );
          border-top: 2px solid #078cc8;
          line-height: 59px;
        }
        .barCanvas1Div {
          height: 221px;
          display: flex;
          align-items: center;
        }
        .colorlist1 {
          // height: 232px;
          width: calc(100% - 210px);
          padding-top: 5px;
          > div {
            display: flex;
            align-items: center;
            padding-bottom: 17px;
            span {
              color: rgba(255, 255, 255, 0.8);
              display: inline-block;
              font-size: 20px;
            }
            .icon {
              width: 18px;
              height: 18px;
              margin-right: 5px;
              border-radius: 13px;
            }
            .text {
              width: calc(100% - 30px);
            }
          }
        }
        .barCanvas1 {
          height: 210px;
          width: 210px;
          align-items: center;
          position: relative;
          .anpng {
            position: absolute;
            width: 210px;
            z-index: 100;
            left: -8px;
            top: 0;
          }
        }
        .emptyData {
          position: absolute;
          left: 0;
          top: 60px;
          width: 100%;
          height: calc(100% - 60px);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: rgba(255, 255, 255, 0.4);
        }
      }
      .mainDivr-m3 {
        position: relative;
        .title {
          font-size: 26px;
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          background-image: linear-gradient(
            180deg,
            #00305f 0%,
            rgba(7, 140, 200, 0.05) 100%
          );
          border-top: 2px solid #078cc8;
          line-height: 59px;
        }
        .barCanvas2Div {
          height: 221px;
          display: flex;
          align-items: center;
        }
        .colorlist2 {
          // height: 232px;
          width: calc(100% - 210px);
          padding-top: 10px;
          > div {
            display: flex;
            align-items: center;
            padding-bottom: 17px;
            span {
              color: rgba(255, 255, 255, 0.8);
              display: inline-block;
              font-size: 20px;
            }
            .icon {
              width: 18px;
              height: 18px;
              border-radius: 13px;
              margin-right: 5px;
            }
            .text {
              width: calc(100% - 30px);
            }
          }
        }
        .barCanvas2 {
          height: 210px;
          width: 210px;
          align-items: center;
          position: relative;
          .anpng {
            position: absolute;
            width: 210px;
            z-index: 100;
            left: -8px;
            top: 0;
          }
        }
        .emptyData {
          position: absolute;
          left: 0;
          top: 60px;
          width: 100%;
          height: calc(100% - 60px);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: rgba(255, 255, 255, 0.4);
        }
      }
      .mainDivr-m4 {
        height: 211px;
        .title {
          background: #00579c;
          font-size: 24px;
          color: #04dbdb;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 59px;
          .num {
            font-size: 36px;
            color: rgba(255, 255, 255, 0.8);
            letter-spacing: 0.95px;
          }
        }
        .datahead {
          display: flex;
          font-size: 20px;
          color: #078cc8;
          line-height: 45px;

          span {
            text-align: center;
          }
          .sp1 {
            width: 25%;
          }
          .sp2 {
            width: 25%;
          }
          .sp3 {
            width: 25%;
          }
          .sp4 {
            width: 25%;
          }
        }
        .datarowDiv {
          height: calc(100% - 104px);
          overflow: hidden;
        }
        .datarow {
          font-size: 22px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 53px;
          display: flex;
          span {
            text-align: center;
          }
          .sp1 {
            width: 25%;
          }
          .sp2 {
            width: 25%;
          }
          .sp3 {
            width: 25%;
          }
          .sp4 {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>
<style lang="less"></style>
